import { showOnlyCurrentClicked } from "../../actions/filters";

import { connect } from "react-redux";

import CheckBox from "../../../../shared_components/check_box";

const mapStateToProps = (state) => {
  const value = "ignore";
  const checked = state.filters.showOnlyCurrent == "checked";
  const title = "Show only current standards";
  const extraHtmlClasses = { "col-md-3": true };

  return { value, checked, title, extraHtmlClasses };
};

const mapDispatchToProps = dispatch => ({
  onClick: () => { dispatch(showOnlyCurrentClicked()); }
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckBox);
